const urlMinify = {
  shorten: async (url: string) => {
    let tinyUrl = null;
    try {
      const response = await fetch('https://tinyurl.com/api-create.php?url=' + encodeURIComponent(url), {
        method: 'GET',
        cache: 'no-cache',
        credentials: 'omit',
        referrerPolicy: 'no-referrer',
        headers: {
          'content-type': 'text/plain',
        },
      });

      if (response.ok) {
        tinyUrl = await response.text();
      } else {
        // On error we return the same url.
        tinyUrl = url;
      }
    } catch (_) {
      tinyUrl = url;
    }

    return tinyUrl;
  },
};

export default urlMinify;
